import React, { useState } from 'react';
import ReusableTable from '../../common/ReusableComponent/reusableTable/ReusableTable';
import useApi from '../../../utils/api-manager/Helper/useApi';
import { ToastContainer } from 'react-toastify';
import EmployeeFaceTooltip from '../Timecard/EmployeeLog/EmployeeImageTooltip';

function EventData() {
  const { GetPaginatedData } = useApi();
  const [loading, setLoading] = useState(false);

  const fetchData = async ({ page = 1, searchTerm = '' } = {}) => {
    try {
      setLoading(true);
      const response = await GetPaginatedData('eventData', { page, search: searchTerm });
      const data = response?.data || [];
      const totalPages = Math.ceil((response?.totalCount || 0) / 10);
      return { data, totalPages };
    } catch (error) {
      console.error('Error fetching events:', error);
      return { data: [], totalPages: 1 };
    } finally {
      setLoading(false);
    }
  };

  const columns = [
  { header: 'Object Type', field: 'object_type' },
  { header: 'Camera',      field: 'camera_name' },
  { header: 'Confidence',  field: 'confidence' },
  { header: 'Severity',    field: 'severity' },
  // { header: 'Status',      field: 'is_acknowledged' },
  {
    header: 'Snapshot',
    field: 'snapshot_url',
    render: (row) => row.snapshot_url
      ? <EmployeeFaceTooltip imagePath={row.snapshot_url} />
      : '—'
  },
  // { header: 'Created At',  field: 'created_at' },
];

  return (
    <>
      <div className="responsive-box" style={{ padding: '20px' }}>
        <div className="header-row">
          <div className="setting-title">Events</div>
        </div>
        <ReusableTable
          fetchData={fetchData}
          columns={columns}
          showAction={false}
          enablePagination={true}
          showFooter={true}
          loading={loading}
        />
      </div>
      <ToastContainer />
    </>
  );
}

export default EventData;
